import React from 'react';

export function Avatar({ firstName, lastName }: { firstName: string; lastName: string }) {
	const initials = (firstName[0] ?? '') + (lastName[0] ?? '');
	return (
		<div className="flex size-8 shrink-0 items-center justify-center rounded-full bg-green-100">
			<span className="text-[11px] font-bold tracking-tight text-green-800">{initials.toUpperCase()}</span>
		</div>
	);
}
